import moment from "moment"
import { useEffect, useState } from "react"
import styled from "styled-components"
import { addComma } from "../utils/Utils"
import { Product, Products } from "../commons/Const"

type Props = {
  onChange?: (product: Product, payMethod: number) => void
}

type ProductInfo = {
  name: string
  price: number
  payMethod: number
}

export default function OrderSubscriptionView(props: Props) {

  const [selectedProduct, setSelectedProduct] = useState<Product|undefined>()
  const [productList, setProductList] = useState<Product[]>([Products[2], Products[3]])
  const [payMethod, setPayMethod] = useState(0);

  useEffect(() => {
    if(process.env.REACT_APP_MODE === 'stage') {
      setProductList([Products[0], ...productList]);
    }
  }, [])

  useEffect(() => {
    setSelectedProduct(productList[0]);
  }, [productList])
  
  useEffect(() => {
    if(selectedProduct === undefined) return;
    
    if(props.onChange) props.onChange(selectedProduct, payMethod)
  }, [selectedProduct, payMethod])

  if(selectedProduct === undefined) return <></>

  return(
    <OrderSubscriptionDiv className="order-subscription">
      <p className="form_label">상품 선택</p>
      <div className="product_list">
        <div className="flex">
          {productList.map(((product, index) => (
            <button
              key={`product${index}`}
              className={`outlined_gray${product.id === selectedProduct.id ? ' active' : ''}`}
              onClick={() => setSelectedProduct(product)}
            >{product.name}</button> 
          )))}
          {/* <button
            className={`outlined_gray${product.id === 3 ? ' active' : ''}`}
            onClick={() => setProduct(Products.find(v => v.id === 3))}
          >특별 자문료</button> */}
        </div>
        <div className="description">
          <p>정기 자문료 선택시 – 정기 자문료를 <span className="green">3회 납부한 이후({moment().add(2, 'months').format('YYYY. M. D.')}부터)</span> 셀러가드 서비스를 이용할 수 있습니다.</p>
          <p>특별 자문료 선택시 – 정기 자문료를 3회 납부하기 전이라도 <span className="green">즉시</span> 셀러가드 서비스를 이용할 수 있습니다.</p>
          {/* <p>정기자문료(타입A) 자문료 – 월 <span className="green">10만원</span>(VAT별도)이며, 셀러는 <span className="green">추가 비용 없이</span> 모든 셀러가드 서비스를 이용할 수 있습니다.</p>
          <p>정기자문료(타입B) 자문료 – 월 <span className="green">7만원</span>(VAT별도)이며, 셀러는 홈페이지 기재 <span className="green">추가 비용</span>을 지불하고 셀러가드 서비스를 이용할 수 있습니다.</p> */}
        </div>
      </div>

      <p className="form_label">결제 방법</p>
      <div className="payment_type flex">
        <button
          className={`outlined_gray${payMethod === 0 ? ' active' : ''}`}
          onClick={() => setPayMethod(0)}
        >신용카드</button>
        {/* <button 
          className={`outlined_gray${payMethod === 1 ? ' active' : ''}`}
          onClick={() => setPayMethod(1)}
          disabled={product.id === 3}
        >휴대폰 결제</button> */}
      </div>

      <p className="form_label">결제 금액</p>
      <p className="payment_amount">
        <strong className="fs20 green">{addComma(selectedProduct.price)}</strong>
        <span className="gray_9a"> (VAT 별도)</span>
      </p>
    </OrderSubscriptionDiv>
  )
}

const OrderSubscriptionDiv = styled.div`
  .form_label{
    margin-top: 36px;
  }

  .product_list, .payment_type{
    margin-bottom: 24px;
    button{
      width: 100%;
      height: 46px;
      border-radius: 6px;

      &.active{
        border-color: var(--main);
        color: var(--main_hover);
      }

      + button{
        margin-left: 12px;
      }
    }

    .description{
      margin-top: 12px;

      p, span{
        line-height: 1.5;
        font-size: 12.5px;
      }

      p+p{
        margin-top: 6px;
      }
    }
  }
`